import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { restStopLocationSchema } from '../schemas/rest-stop-location.schema';

/**
 * Returns  response for Rest Stop Locations
 * @returns List of Rest Stop Locations
 */
export function getPreferencesRestStopLocations(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment.resolve(this).preferencesReststoplocationsUrl,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(z.array(restStopLocationSchema)));
}
